import Showdown from "showdown";

const converter = new Showdown.Converter();

interface Props {
  content?: string;
}

export function Markdown({ content }: Props) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: converter.makeHtml(content ?? ""),
      }}
    />
  );
}
